export default __webpack_public_path__ + "static/media/waiting_for_sampling.368a676f.svg";